import clsx from 'clsx'
import Image from 'next/image'

import Link from '@/atoms/Link/Link'

interface Props {
  primaryHeadline: string
  subText: string
  class?: string
  tag?: string
  primaryCta: StrapiLinkSharedComponent
  secondaryCta?: StrapiLinkSharedComponent | null
  image?: {
    url: string
    alternativeText?: string
    mime: string
    height: number
    width: number
  }
  bgColor?: string
}

function SignUp({
  primaryHeadline,
  subText,
  primaryCta,
  secondaryCta,
  image,
  bgColor,
  ...props
}: Props) {
  return (
    <section
      className={clsx('bg-blue-web-90 text-white', props.class)}
      style={{ background: bgColor ?? '' }}
    >
      <div className="container | font-heading | grid grid-cols-4 lg:grid-cols-12 | gap-x-8 gap-y-12 items-center | text-left | py-10 md:py-18">
        <div className="col-span-4 lg:col-span-6">
          {props.tag ? (
            <span
              className="block | text-xl uppercase | mb-7 md:mb-6"
              dangerouslySetInnerHTML={{ __html: props.tag }}
            />
          ) : null}
          {primaryHeadline ? (
            <h1
              className="title | text-3xl lg:text-5xl font-semibold tracking-tight | mb-4"
              dangerouslySetInnerHTML={{ __html: primaryHeadline }}
            />
          ) : null}
          {subText ? (
            <h2
              className="font-body text-lg lg:text-xl | mb-10 lg:mb-12"
              dangerouslySetInnerHTML={{ __html: subText }}
            />
          ) : null}
          <div className="font-body font-medium | flex flex-col sm:flex-row justify-center md:justify-start gap-4 | w-full mb-6">
            <Link
              href={primaryCta.href}
              className={clsx(
                'new-btn-tertiary | font-medium',
                !secondaryCta?.href ? 'flex-grow max-w-[351px]' : ''
              )}
            >
              {primaryCta.title}
            </Link>
          </div>
        </div>
        <div className="col-span-4 lg:col-start-8 lg:col-span-5">
          {image && (
            <Image
              src={image.url}
              alt={image.alternativeText ?? ''}
              width={image.width}
              height={image.height}
              className="rounded-2xl | w-full max-w-col-6 | mx-auto"
              priority
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default SignUp
